import { useGlobalStore } from "@/store/GlobalStore";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Link } from "task-eva-ui";
import GrayWarningIcon from "@/assets/icons/common/gray-warning";

export function AuthStatusTip() {
  const {
    userInfo,
    isSubAccount,
    setShowAuthenticateModal,
    showAuthStatusTip,
  } = useGlobalStore();
  const { t } = useTranslation("common");

  if (!showAuthStatusTip) return null;

  if (isSubAccount) return <span>{t("common_auth_status_tips_sub")}</span>;
  return (
    <AuthStatusTipWrapper>
      <GrayWarningIcon />
      {t("common_auth_status_tips_1")}
      <Link
        onClick={() => {
          setShowAuthenticateModal(true);
        }}
      >
        {t("common_auth_status_tips_2")}
      </Link>
      <span>
        {t("common_auth_status_tips_3", {
          0: userInfo?.authGiveAway,
        })}
      </span>
    </AuthStatusTipWrapper>
  );
}

const AuthStatusTipWrapper = styled.div`
  display: flex;
  align-items: center;
  background: #000000;
  height: 40px;
  line-height: 40px;
  padding: 0 32px;
  white-space: pre;
  color: #bfc2c3;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  > svg:first-child {
    margin-right: 8px;
  }
  a {
    color: var(--main-color);
  }
  a:hover {
    color: var(--main-color);
  }
`;
